import { createFileRoute } from '@tanstack/react-router'
import { GitMerge } from 'lucide-react'
import { MergeReviewScreen } from '@/screens/investigate/SCR-024-merge'

function BranchRoute() {
  const { branchId } = Route.useParams()
  return <MergeReviewScreen key={branchId} branchId={branchId} />
}

export const Route = createFileRoute('/_app/w/$ws/branches_/$branchId')({
  staticData: { screen: { id: 'SCR-024', title: 'Merge review', group: 'Investigate', perm: 'branch.manage', hidden: true, description: 'Every change on a branch, its conflicts and your decision.', icon: GitMerge } },
  component: BranchRoute,
})
